import { motion } from "framer-motion";

/**
 * Slow editorial marquee — massive display font, single-line loop.
 */
export default function Marquee({
  items,
  bg = "var(--ink)",
  color = "var(--cream)",
  accent = "var(--meme-yellow)",
  slow = true,
  reverse = false,
  size = "text-[12vw] md:text-[9vw]",
  border = true,
}) {
  const list = items && items.length ? items : [
    "BAT",
    "RAT",
    "HAT",
    "RAT",
    "FAT",
    "USDC",
    "MEME",
  ];
  // duplicate for seamless loop
  const track = [...list, ...list, ...list, ...list];

  return (
    <div
      className={`relative w-full overflow-hidden ${
        border ? "border-y-2 border-[color:var(--ink)]" : ""
      }`}
      style={{ backgroundColor: bg, color }}
      data-testid="marquee"
    >
      <div className={`ticker-track ${slow ? "slow" : ""} ${reverse ? "reverse" : ""} py-4 md:py-6`}>
        {track.map((w, i) => (
          <span
            key={i}
            className={`font-display uppercase ${size} px-6 flex items-center gap-6`}
          >
            {w}
            <motion.span
              aria-hidden
              className="inline-block"
              style={{ color: accent, transform: "translateY(-6%)" }}
            >
              ✦
            </motion.span>
          </span>
        ))}
      </div>
    </div>
  );
}
